import { useTheme } from 'styled-components'

import { IconBase, IconProps } from './Base'

export const IconVaults = (props: IconProps) => {
  const theme = useTheme()

  return (
    <IconBase width={props.width || 17} height={props.height || 16} viewBox="0 0 17 16" fill="none">
      <g clipPath="url(#clip0_3009_4364)">
        <path
          d="M15.5667 4.66663L9.90007 10.3333L6.56673 6.99996L2.2334 11.3333"
          stroke={theme.colors.text.primary}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.5664 4.66663H15.5664V8.66663"
          stroke={theme.colors.text.primary}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3009_4364">
          <rect width="16" height="16" fill={theme.colors.background.primary} transform="translate(0.899902)" />
        </clipPath>
      </defs>
    </IconBase>
  )
}
